/**
 * PayPal checkout countries and currencies.
 * Keep in sync with functions/paypalCurrencies.js
 *
 * UK (GB) stays on A2B/Cardstream in GBP. PayPal is used for:
 * US → USD, CA → CAD, IE/EU → EUR, AU → AUD, NZ → NZD.
 */

export const PAYPAL_CHECKOUT_CURRENCIES = Object.freeze({
  US: 'USD',
  CA: 'CAD',
  IE: 'EUR',
  EU: 'EUR',
  AU: 'AUD',
  NZ: 'NZD',
});

const CURRENCY_LABELS = {
  USD: 'US dollars (USD)',
  CAD: 'Canadian dollars (CAD)',
  EUR: 'euros (EUR)',
  AUD: 'Australian dollars (AUD)',
  NZD: 'New Zealand dollars (NZD)',
};

export function getPayPalCurrencyForCountry(countryCode) {
  const cc = String(countryCode || '').toUpperCase();
  return PAYPAL_CHECKOUT_CURRENCIES[cc] || null;
}

export function isPayPalCheckoutCountry(countryCode) {
  return Boolean(getPayPalCurrencyForCountry(countryCode));
}

export function paypalPaymentProviderForCountry(countryCode) {
  const cc = String(countryCode || '').toUpperCase();
  if (!PAYPAL_CHECKOUT_CURRENCIES[cc]) return null;
  return cc === 'US' ? 'paypal_us' : 'paypal';
}

export function isPayPalPaymentProvider(provider) {
  const p = String(provider || '').toLowerCase();
  return p === 'paypal_us' || p === 'paypal';
}

export function paypalCurrencyDisplayName(currencyCode) {
  const code = String(currencyCode || '').toUpperCase();
  return CURRENCY_LABELS[code] || code;
}
